<template>
  <div class="main-page process">
    <Menus
      title="进度查询"
      :home="true"
    />
    <div class="container-flex">
      <div class="process-list">
        <div
          v-if="showDefalt "
          class="pageStateTip"
        >
          <div class="imgs">
            <img
              src="/img/ui/legal-default.png"
              alt
            >
          </div>
          <div class="ht">
            <h1>您还没有进行法律援助</h1>
          </div>
          <div class="cancelResevation">
            <p>点击下方按钮免费开始申请</p>
            <router-link
              to="/legalaid/apply"
              class="btns"
            >
              在线申请法律援助
            </router-link>
          </div>
        </div>
        <template v-else>
          <div
            v-for="(item,index) in list"
            :key="'key-'+index"
            class="item"
          >
            <div class="content">
              <div class="name">
                <span v-if="item.aid_info[0]&&item.aid_info[0].PersonName">申请人：{{ item.aid_info[0].PersonName }}</span>
                <span v-else>申请人：空</span>
              </div>
              <div class="time">
                申请时间：{{ item.created }}
              </div>
              <div class="info">
                办理状态：<span v-if="item.aid_info&&item.aid_info[0].AcceptStatusName">{{item.aid_info[0].AcceptStatusName}}</span>
                <span v-else>空</span>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import Menus from '@/components/Menu'
import { LEGALAID_INQUIRE } from '../../datas/constants/statistics.js'
export default {
  components: {
    Menus
  },
  data () {
    return {
      status: 1,
      list: [],
      showDefalt: 0,
      backhome: false
    }
  },
  mounted () {
    let userid = this.$store.state.user.wechatUinfo.userid
    this.$loading.show()
    this.getList(userid)
    this.$root.getStatistics(LEGALAID_INQUIRE)
  },
  methods: {
    async getList (userid) {
      const { result, msg, status } = await this.$get(
        `https://yn.12348.laway.cn/api/user/legacase/list/?user_id=${userid}`
      )
      if (!status) {
        console.log('错误：' + msg)
        return
      }
      console.log(result)
      this.$loading.hide()
      if (result.data.length) {
        this.list = result.data
      } else {
        this.showDefalt = 1
      }
    }

  }
}
</script>
<style lang="stylus" scoped>
</style>
